import { createSelector } from '@ngrx/store'

export const getNotDeliveredReasonListState = createSelector(
  (state: any) => state.notDeliveredReason,
  (state: any) => state.get('list'),
)

export const getCreateNotDeliveredReasonState = createSelector(
  (state: any) => state.notDeliveredReason,
  (state: any) => state.get('create'),
)

export const getUpdateNotDeliveredReasonState = createSelector(
  (state: any) => state.notDeliveredReason,
  (state: any) => state.get('update'),
)
